module.exports = __webpack_public_path__ + "img/delete.b9a27a75.svg";